import { useParams } from "react-router-dom";
import { useAccount } from "../../hooks/QueryHooks";
import useWorkspaceStore from "../../store/workspace/workspaceStore";
import AccountCrumbs from "../../pages/home/account-details/components/AccountCrumbs";

const AccountViewHeaderContent = () => {
  const { accountId }: any = useParams();
  const workspaceId = useWorkspaceStore((state) => state.workspace?.id);
  const { data: accountData }: any = useAccount({
    workspaceId,
    accountId,
    enabled: !!accountId && !!workspaceId,
  });

  return <AccountCrumbs accountName={accountData?.name} />;
};

export default AccountViewHeaderContent;
